export { default } from "./ListIngredientesProductos";
